<template>
  <section>
    <div class="row">
      <div class="col-sm-12">
        <table class="table risk">
          <thead>
            <tr>
              <th rowspan="2">Fund</th>
              <th colspan="3" class="text-center">Risk Rating</th>
            </tr>
            <tr>
              <th class="text-center">Capital</th>
              <th class="text-center">Inflation</th>
              <th class="text-center">Conversion**</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ blockData.fund_name }}</td>
              <td class="text-center">{{ blockData.capital }}</td>
              <td class="text-center">{{ blockData.inflation }}</td>
              <td class="text-center">{{ blockData.conversion }}</td>
            </tr>
          </tbody>
        </table>
        <div class="table-footer">{{ blockData.footer }}</div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    blockData: Object,
  },
};
</script>
